<template>
  <div>
    <div class="list-wrap" v-if="list.length>0">
      <div class="order-word">
        您正在预约{{ tenantNameInfo + carTeamNameInfo }}的路考,
        可预约最近1个月空闲的时段，请选择:
      </div>
      <van-pull-refresh  v-model="isLoading" @refresh="onRefresh">
        <van-list
          class="list-item"
          :finished="finished"
          v-model="loading"
          @load="onLoad"
          :offset="130" 
          :immediate-check="false"
        >
          <van-cell
            v-for="item in list"
            :key="item.id"
            :class="['item-show', showId === item.id ? 'card-show' : '']"
            @click="handleClick(item.examAddressId, item.id)"
          >
            <div class="item-wrap" v-if="showId !== item.id">
              <div>
                <span>{{ item.appointmentTime | getAppointmentTimeDay }}</span>
                <span class="item-hour">
                  {{ item.appointmentTimeStart | getAppointmentTimeHour }}—{{
                    item.appointmentTimeEnd | getAppointmentTimeHour
                  }}
                </span>
              </div>
              <span
                class="btn-order"
                >可预约</span
              >
            </div>
            <div v-else class="item-card">
              <div class="time-show">
                <span>{{ item.appointmentTime | getAppointmentTimeDay }}</span>
                <span class="item-hour">
                  {{ item.appointmentTimeStart | getAppointmentTimeHour }}—{{
                    item.appointmentTimeEnd | getAppointmentTimeHour
                  }}
                </span>
              </div>
              <div class="exam">
                <span class="label">考点</span>
                <div class="value">{{ carTeamName + name }}</div>
              </div>
              <div class="line"></div>
              <div class="address">
                <span class="label">地址</span>
                <div class="value">{{ address }}</div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="list_nodata" v-else>
      <img src="@/assets/images/roadnodata.png"/>
      <p>近30天内暂无路考哦～</p>
    </div>
    <div class="bottom-fix">
      <div
        :class="
          !isSelect
            ? 'info_content_dis_btn'
            : 'info_content_dis_btn info_content_btn'
        "
        @click="btnClick"
      >
        立即预约
      </div>
    </div>
  </div>
</template>

<script>
import { reqExamTimeList, reqExamAddress, reqAppointExamAddress, reqUserInfo } from "@/apis/serviceApi";
import { dateFormat } from "@/utils/dateFormat.js";
export default {
  name: "TestList",
  data() {
    return {
      list: [], 
      totalPage: 0,
      finished: false,
      loading: false,
      showId: 0,
      isSelect: false,
      tenantNameInfo: "",
      carTeamNameInfo: "",
      carTeamName: "",
      name: "",
      address: "",
      pageSize: 20,
      pageNum: 1,
      isLoading: false,
    };
  },
  mounted() {
    this.onRefresh()
    this.getUserInfo();
  },
  filters: {
    getAppointmentTimeHour(val) {
      return dateFormat("HH:MM", new Date(val));
    },
    getAppointmentTimeDay(val) {
      return dateFormat("mm月dd日", new Date(val));
    }
  },
  methods: {
    // 可预约时间段查询
    getExamTimePageList() {
      const { tenantId } = this.$route.query
      this.loading = true
      reqExamTimeList({ pageSize: this.pageSize, pageNum: this.pageNum, domainType: 200, tenantId}, 7000)
      .then(res => {
        this.loading =false
        if (res.code === 1) {
          console.log('预约列表==', res.data)
          const { totalPage, items } = res && res.data
          this.list = [...this.list, ...items];
          if (this.pageNum >= totalPage) {
            this.finished = true
          }
        }
      })
      .catch(err => {
        console.log("错误信息", err);
      });
    },
    // 可预约按钮点击
    handleClick(examAddressId, itemId) {
      const { tenantId } = this.$route.query
      reqExamAddress({ examAddressId: examAddressId, domainType: 200, tenantId })
        .then(res => {
          if (res.code === 1) {
            this.showId = itemId;
            let { data = {} } = res;
            let { carTeamName = "", name = "", address = "" } = data;
            this.carTeamName = carTeamName;
            this.name = name;
            this.address = address;
            this.isSelect = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 立即预约按钮点击
    btnClick() {
      const { tenantId } = this.$route.query
      if(!this.isSelect){
        return 
      }else {
        reqAppointExamAddress({ timeConfigId: this.showId, domainType: 200, tenantId })
        .then(res => {
          console.log('立即预约数据===', res);
          if(res.code && res.code === 1){
            if (res.data && Boolean(res.data) === true) {
              this.$parent.getActiveState();
            }
          }else {
            this.$toast.fail(res.msg);
            setTimeout(() => {
              this.$parent.getActiveState();
            }, 500)
          }
        })
        .catch(err => {
          if (err) {
            console.log(err);
            this.$toast.fail(err.msg);
          }
        });
      }
    },
    // 获取租户名称和运力车队
    getUserInfo() {
      const { tenantId } = this.$route.query
      reqUserInfo({ domainType: 200, tenantId }).then(res => {
        if (res.code === 1) {
          console.log('所属代驾和供应商数据===', res)
          let { tenantName = "", carTeamName = "" } = res && res.data;
          this.tenantNameInfo = tenantName;
          this.carTeamNameInfo = carTeamName;
        }
      });
    },
    onLoad() {
      this.pageNum++
      setTimeout(() => {
        this.getExamTimePageList()
      }, 500)
    },
    onRefresh() {
      this.isLoading = false
      this.list = []
      this.pageNum = 1
      this.showId = 0 // 恢复默认列表样式
      this.isSelect = false // 刷新时清空按钮选中样式
      this.loading = false
      this.finished = false
      this.getExamTimePageList()
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-cell::after{
  border-bottom: none;
}
.list-wrap {
  background: #ffffff;
  border-radius: 14px;
  margin-top: 16px;
  padding: 34px 32px 100px;
  .order-word {
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #333333;
    text-align: justify;
    line-height: 42px;
    font-weight: bold;
  }
  .list-item {
    .item-show {
      font-family: PingFangSC-Regular;
      background: #ffffff;
      border: 1px solid #dfdfdf;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.04);
      border-radius: 8px;
      width: 100%;
      font-size: 32px;
      margin-top: 20px;
      padding: 28px 32px;
      line-height: 44px;
      .item-wrap {
        display: flex;
        justify-content: space-between;
        .item-hour {
          margin-left: 20px;
        }
        .btn-order {
          text-decoration: underline;
          color: #176af0;
        }
      }
    }
    .card-show {
      background: #f3f8ff;
      border: 2px solid #176af0;
      .item-card {
        .time-show {
          font-family: PingFangSC-Medium;
          font-size: 36px;
          color: #176af0;
          font-weight: bold;
          line-height: 44px;
          .item-hour {
            display: inline-block;
            margin-left: 28px;
          }
        }
        .address,
        .exam {
            display: flex;
            justify-content: flex-start;
          .label {
            font-family: PingFangSC-Medium;
            font-size: 32px;
            color: #333333;
            line-height: 44px;
            margin-right: 24px;
            text-align: justify;
            font-weight: bold;
          }
          .value {
            width: calc(100% - 152px);
            display: inline-block;
            font-family: PingFangSC-Regular;
            font-size: 32px;
            color: #666666;
            line-height: 44px;
            text-align: justify;
          }
        }
        .line {
          background: #e8eae9;
          height: 1px;
          margin-top: 16px;
          margin-bottom: 16px;
        }
        .exam {
          margin-top: 24px;
        }
      }
    }
  }
}
.list_nodata{
  height: 50vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  font-size: 32px;
  color: #9F9F9F;
  font-weight: bold;
  img{
    width: 320px;
    height: 320px;
  }
}
.bottom-fix {
  width: 100%;
  height: 144px;
  left: 0px;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  font-weight: bold;
  .info_content_dis_btn {
    background: #c8c9cd;
    border-radius: 16px;
    width: calc(100% - 40) px;
    height: 104px;
    margin: 20px 20px 0px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    color: #ffffff;
  }
  .info_content_btn {
    background-image: linear-gradient(270deg, #27a0ff 0%, #176af0 100%);
  }
}
</style>
